import { useParams } from 'react-router-dom';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import FlightBookingDetails from '../../components/FlightBookingDetails/FlightBookingDetails';

const FlightBookingDetailsPage = () => {
  const { flightId } = useParams();

  // Mock flight data - replace with actual API call
  const flightData = {
    aircraft: 'SASA',
    departure: 'LCG',
    departureTime: '19:05 PM',
    arrival: 'AAL',
    arrivalTime: '18:30 PM',
    duration: '3 hrs 30 Mins',
    seats: 4,
    flightNumber: 'SASA',
    etd: '17 Feb 2026, 19:05',
    eta: '19 Feb 2026, 18:30',
    flightTime: '3 hrs 30 Mins',
    totalFlightTime: '3 hrs 30 Mins',
    addOns: '$5',
    totalFare: '$185',
    image: '/hero-image.jpeg'
  };

  const carouselImages = [
    '/hero-image.jpeg',
    '/gallery1.jpeg',
    '/gallery3.jpeg',
    '/gallery4.jpeg',
    '/gallery5.jpeg'
  ];

  const handleBook = () => {
    console.log('Booking flight:', flightId);
    // Add booking logic here
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      <main className="flex-grow">
        <FlightBookingDetails 
          flightData={flightData}
          carouselImages={carouselImages}
          onBook={handleBook}
        />
      </main>
      <Footer />
    </div>
  );
};

export default FlightBookingDetailsPage;
